import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { gql } from '@apollo/client';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Placeholder from 'components/consumer/Placeholder';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import CardCarousel from 'components/consumer/image-slider-standard/components/CardCarousel';
import JBImage from 'components/essentials/JBImage';
import ToggleCTALinkButtonWithoutDesignServices from 'components/essentials/ToggleCTALinkButtonWithoutDesignServices';
import Link from 'components/consumer/Link';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useScreen from 'hooks/useScreen';
import useIsBrowser from 'hooks/useIsBrowser';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import { addMainImages } from '../collections-page/withState';
import EmblaCarousel, { EmblaSlide } from '../image-slider-standard/components/EmblaCarousel';
const GET_COLLECTIONS_LITE = gql`
  query getCollectionsLite($filters: ProductFiltersInput) {
    getCollections(filters: $filters) {
      collections {
        id
        url: slug
        name
        category_label
        category_description
        category_meta_description
      }
    }
  }
`;
const ConsumerCollectionsSlider = props => {
  const $ = _c(28);
  const isBrowser = useIsBrowser();
  const {
    config: t0
  } = props;
  const {
    heading,
    subHeading,
    toggleInputType
  } = t0;
  const isSubHeading = subHeading && subHeading.content;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fetchPolicy: "cache-and-network",
      context: {
        clientTarget: "alexandria"
      },
      ssr: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data,
    error,
    loading
  } = useSuspenseQuery(GET_COLLECTIONS_LITE, t1);
  const collections = !error && !loading && data.getCollections && data.getCollections.collections.length ? addMainImages(data.getCollections.collections.map(_temp)) : [];
  const {
    isDesktop,
    isMobile
  } = useScreen();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      query: "(max-width: 1280px)"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isNotCinema = useMediaQuery(t2);
  const imageSize = isBrowser && isDesktop && isNotCinema ? 390 : 340;
  let t3;
  if ($[2] !== imageSize) {
    t3 = {
      width: imageSize,
      height: imageSize,
      trim: "auto"
    };
    $[2] = imageSize;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const imageSizeProps = t3;
  let t4;
  if ($[4] !== imageSizeProps) {
    t4 = () => Array.from(Array(4).keys()).map(i => <button type="button" className={classNames("block float-left w-full !text-gray no-underline hover:!no-underline focus-visible:rounded-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]", "flex-[1_1] flex-col justify-between items-center min-w-[80%] sm:min-w-[33.333%] lg:min-w-[25%]", "[&_img]:object-cover [&_img]:block")} key={i} to="#" aria-label="Loading"><div className="bg-gray-light8"><Placeholder loading={true} type="rect" style={{
          ...imageSizeProps,
          marginLeft: "5px",
          marginRight: "5px"
        }} /></div><h5 className="mt-3 mb-[.312rem] text-xl font-bold"><Placeholder loading={true} style={{
          width: 134,
          height: 22,
          marginLeft: "5px",
          marginRight: "5px"
        }} /></h5><div className="text-sm text-gray"><Placeholder loading={true} style={{
          width: "100%",
          height: 20,
          marginLeft: "5px",
          marginRight: "5px"
        }} /><Placeholder loading={true} style={{
          width: "100%",
          height: 20,
          marginLeft: "5px",
          marginRight: "5px"
        }} /></div></button>);
    $[4] = imageSizeProps;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getLoaders = t4;
  let t5;
  if ($[6] !== imageSizeProps) {
    t5 = collectionsToRender => collectionsToRender.map(collection_0 => {
      const imageSrc = collection_0.images[0] && collection_0.images[0].url;
      const collectionName = collection_0.name.replace(" Collection", "");
      const slideContent = <Link className={classNames("block float-left w-full !text-gray no-underline hover:!no-underline focus-visible:rounded-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]", "flex-[1_1] flex-col justify-between items-center min-w-[80%] sm:min-w-[33.333%] xl:min-w-[25%]", "[&_img]:object-cover [&_img]:block", {
        "mx-0 px-0": isNewConsumerApp
      })} key={collection_0.id} to={collection_0.url} aria-label={collectionName}><JBImage alt="" {...imageSizeProps} src={imageSrc} /><h3 className="mt-3 mb-[.312rem] text-xl font-bold">{collectionName}</h3><p className="text-sm text-gray">{collection_0.category_description || collection_0.category_meta_description}</p></Link>;
      if (isNewConsumerApp) {
        return <EmblaSlide className="flex-grow flex-shrink basis-[80%] sm:basis-1/3 lg:basis-1/4" key={collection_0.id}>{slideContent}</EmblaSlide>;
      }
      return slideContent;
    });
    $[6] = imageSizeProps;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const getChildren = t5;
  const T0 = FixedWidthContainer;
  const t6 = true;
  const t7 = "ConsumerCollectionsSlider";
  const t8 = "min-h-[500px] mx-0 my-6 [&_a]:no-underline [&_.slider-control-centerright]:!top-[35%] [&_.slider-control-centerleft]:!top-[35%] [&_.slider-control-centerleft]:!left-[3px] [&_.slider-control-centerright]:!right-[3px]";
  const t9 = heading && heading.content || "";
  let t10;
  if ($[8] !== t9) {
    t10 = <h2 className="max-[767px]:pl-5 max-[767px]:pr-5 m-0 text-2xl font-bold">{t9}</h2>;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== isSubHeading || $[11] !== subHeading) {
    t11 = isSubHeading && <p className="max-[767px]:pl-5 max-[767px]:pr-5 font-normal">{subHeading.content}</p>;
    $[10] = isSubHeading;
    $[11] = subHeading;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== getLoaders || $[14] !== isBrowser) {
    t12 = !isBrowser && <CardCarousel imageHeight={350} imageWidth={350} navType="Button" variant="collections-slider" visibleSlides={4}>{getLoaders()}</CardCarousel>;
    $[13] = getLoaders;
    $[14] = isBrowser;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = isBrowser && !error && !isNewConsumerApp && <CardCarousel imageHeight={350} imageWidth={350} navType="Button" variant="collections-slider" visibleSlides={4}>{getChildren(collections)}</CardCarousel>;
  const t14 = isBrowser && !error && isNewConsumerApp && <EmblaCarousel className="gap-0 sm:gap-2.5 px-5 md:px-0" slideSpacing={isMobile ? "0px" : "10px"} variant="collections-slider">{getChildren(collections)}</EmblaCarousel>;
  let t15;
  if ($[16] !== toggleInputType) {
    t15 = !!toggleInputType && <div className="max-[767px]:pl-5 max-[767px]:pr-5"><ToggleCTALinkButtonWithoutDesignServices toggleInputType={toggleInputType} linkClassName="!pl-0" /></div>;
    $[16] = toggleInputType;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
    t16 = <div className={t8}>{t10}{t11}{t12}{t13}{t14}{t15}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== T0 || $[26] !== t16) {
    t17 = <T0 noMobilePadding={t6} className={t7}>{t16}</T0>;
    $[25] = T0;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
};
ConsumerCollectionsSlider.propTypes = {
  config: PropTypes.shape({
    heading: PropTypes.shape({
      content: PropTypes.string
    }),
    subHeading: PropTypes.shape({
      content: PropTypes.string
    }),
    toggleInputType: PropTypes.object
  })
};
export default ConsumerCollectionsSlider;
function _temp(collection) {
  if (collection.url && !collection.url.startsWith("/")) {
    return {
      ...collection,
      url: `/${collection.url}`
    };
  }
  return collection;
}